/**
 * Computes the tri-state Meta connection status for the edit screen.
 * stateFormNumber: local component state (used for id/api, stable across a session)
 * propsFormNumber: live provider props (used for containerInfo, updated asynchronously)
 */
export function getMetaConnectionState(stateFormNumber, propsFormNumber) {
	const isExistingMetaNumber = stateFormNumber?.api === 'meta' && !!stateFormNumber?.id;
	if (!isExistingMetaNumber) return null;

	const info = propsFormNumber?.containerInfo?.info;
	if (!info || info.checkFailed) return 'indeterminate';

	return info.connected ? 'connected' : 'disconnected';
}
